import { Platform } from 'react-native';

export function isElectronRuntime(): boolean {
  return (
    Platform.OS === 'web' &&
    typeof window !== 'undefined' &&
    !!(
      window as unknown as { electron?: { ipcRenderer?: { invoke?: unknown } } }
    ).electron?.ipcRenderer?.invoke
  );
}
